import classNames from "classnames";
import { useContext } from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { useUpdateFinancialDocumentMetadataMutation } from "@api/financialDocument.api";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import type { DatePickerPreset } from "@design-system/DatePicker/DatePicker.types";
import { EditableTableCell } from "../accounting/editableTable/EditableTableCell";
import editableTableStyles from "../accounting/editableTable/EditableTable.module.scss";
import { ImporterContext } from "./importer.context";
import styles from "./ImporterPage.module.scss";

interface Props {
    financialDocument: FinancialDocumentExtended;
    field: "openingDate" | "closingDate";
    presets?: ReadonlyArray<DatePickerPreset<string>>;
}

export const ImporterStatementDateCell: React.FC<Props> = ({
    financialDocument,
    field,
    presets = [],
}) => {
    const { revalidateDocument } = useContext(ImporterContext);
    const updateDocumentMetadata =
        useUpdateFinancialDocumentMetadataMutation(financialDocument);

    return (
        <EditableTableCell
            className={classNames(
                editableTableStyles.dropdownEditableCell,
                styles.editableCell,
                styles.baseSelectEditableCell,
            )}
        >
            <DatePicker
                mode="day"
                variant="button"
                clearable={false}
                showTriggerIcon={false}
                displayFormat={fullDateFullYearFormat}
                placeholder="Select"
                showPresets={presets.length > 0}
                presets={presets}
                value={financialDocument[field] ?? undefined}
                onValueChange={(date) => {
                    if (!date) {
                        return;
                    }
                    updateDocumentMetadata.mutate(
                        { [field]: date },
                        {
                            onSuccess: () =>
                                revalidateDocument({
                                    financialDocumentId: financialDocument.id,
                                }),
                        },
                    );
                }}
                buttonProps={{ variant: "primary", size: "md", block: true }}
            />
        </EditableTableCell>
    );
};
